export default "__VITE_ASSET__DDlpS$2a__"